import styled from "styled-components";
import {
    CharcoalBlack,
    White,
    Teal,
    DarkSlate,
    PrimaryOrange,
    NewTeal,
    NewLightTeal,
    DarkerSlate,
    TealNew,
    LightGray,
} from "../../../theme/variable";
import gnb_sprite from "../../../images/gnb_sprite.svg";
import LeftArrow from "../../../images/LeftArrow.png";
import LeftArrowActive from "../../../images/LeftArrowActive.png";
import GNBSprite_New from "../../../images/GNBSprite_New.svg";
import {media} from "../../../theme/responsive";
import needCounselingIcon from "../../../images/ContctUSIconMob.svg";
import contactUsPhoneIcon from "../../../images/contactUsPhoneIcon.svg";
import ContactUsHeadPhnIcn from "../../../images/ContactUsHeadPhnIcn.svg";
import ContactUsPhnIcn2 from "../../../images/ContactUsPhnIcn2.svg";

export const NavLinksLeftSection = styled.div`
    border: none;
    background: none;
    width: 100%;
    height: unset;
    ${media.laptop`
      width: 215px;
      background: ${White};
      // height: 406px;
      min-height:350px;
      border-right: 1px solid #eee;`}
`;

export const DropDownLeft = styled.div`
    width: 100%;
    // border-top: 1px solid #eee;
    ul {
        li {
            width: 100%;
        }
    }
    ${media.laptop`width: 215px;border-top:none;`};
`;
export const DrpDownLabel = styled.label`
    background: unset;
    bottom: 0;
    font-size: 14px;
    padding: 13px 16px;
    cursor: pointer;
    display: inline-block;
    width: 100%;
    color: ${DarkerSlate};
    position: relative;
    border-top: 1px solid #c1e8dc;
    &:hover {
        ${media.laptop`
        border-left: 2px solid ${NewTeal};
        border-right: none;
        background: ${NewLightTeal};
        color: ${TealNew};
        border-bottom: 1px solid #eee;
        border-top: 1px solid #eee;
        `}
    }
    ${media.laptop`
    background:${(props) => (props.labelActive ? "#F5FFFC" : "#fff")};
    border-right:${(props) => (props.labelActive ? "none" : "1px solid #eee")};
    border-left: ${(props) => (props.labelActive ? `2px solid ${NewTeal}` : "")};
    border-bottom: ${(props) => (props.labelActive ? `1px solid #eee` : "1px solid transparent")};
    border-top: ${(props) => (props.labelActive ? `1px solid #eee` : "1px solid transparent")};
        color: ${(props) => (props.labelActive ? `${TealNew}` : `${DarkerSlate}`)};
        padding: 12px 8px;
    `}
`;
export const LeftArrowIcon = styled.i`
    background: url(${GNBSprite_New}) no-repeat;
    display: inline-block;
    width: 17px;
    height: 13px;
    background-position: ${(props) => (props.labelActive ? "-223px -8px" : "-225px -10px;")};
    position: absolute;
    right: 8px;
    top: 15px;
    transform: ${(props) => (props.labelActive ? "rotate(90deg)" : "")};
    ${media.laptop`background: ${(props) =>
        props.labelActive ? `url(${LeftArrowActive})` : `url(${LeftArrow})`}
        no-repeat;
        background-position: 0 0;
        width: 10px;
        height: 11px;
        transform:unset;`}
`;

export const BackTick = styled.div`
    font-weight: 600;
    line-height: 31px;
    width: 14px;
    height: 14px;
    transform: rotate(-135deg);
    position: absolute;
    top: 15px;
    left: 18px;
    border-style: solid;
    border-color: rgb(255, 255, 255);
    border-image: initial;
    border-width: 2px 2px 0px 0px;
`;

export const DrpDownRight = styled.div`
    position: unset;
    width: 100%;
    height: auto;
    padding: ${(props) => (props.labelActive ? "0px 14px 12px 26px" : "0")};
    max-height: ${(props) => (props.labelActive ? "100em" : "0")};
    transition: ${(props) => (props.labelActive ? " max-height 0.6s ease-in-out" : "unset")};
    overflow: hidden;
    ${media.laptop`
    position: absolute;
    width: 813px;
    left: 215px;
    // height: 416px;
    min-height:350px;
    top: 4px;
    padding: 12px 14px;
    display: ${(props) => (props.labelActive ? "block" : "none")};`}
    ul {
        width: 100%;
        li {
            width: 33%;
            display: inline-block;
            float: none !important;
            vertical-align: top;
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
            ${media.laptop`margin-bottom: 20px;`}
        }
    }
`;
export const RightSubMenuList = styled.ul`
    width: 100%;
    && li {
        display: block;
        width: 100%;
        margin-bottom: 12px;
        font-size: 0.75rem;
        &:last-child {
            margin-bottom: 0;
        }
        label,
        a {
            color: ${DarkerSlate};
            font-size: 0.75rem;
            line-height: 16px;
            padding: 0;
        }
        &:hover,
        &:hover a {
            color: #000;
            text-decoration: underline;
        }
        &:first-child {
            &:hover {
                text-decoration: none;
            }
            label {
                font-weight: 600;
                text-decoration: none;
                &:hover {
                    text-decoration: none;
                }
            }
        }
    }
`;
export const HamburgerHeader = styled.div`
    background: ${NewTeal};
    color: ${White};
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding: 0 0 0 16px;
    && a {
        padding: 0;
        color: unset;
    }
    i.CrossIcon {
        font-size: 26px;
        line-height: 21px;
        padding: 14px;
    }
`;

export const AbroadLogoMobile = styled.div`
    background: url(${GNBSprite_New}) no-repeat;
    display: inline-block;
    width: 82px;
    height: 36px;
    background-position: 0 -28px;
`;

export const NavLinks = styled.div`
    // .navLink-left{
    //   width:215px;
    //   background:${White};
    //   height:400px;
    //   border-right:1px solid #eee;
    //   @media screen and (max-width: 1023px) {border:none; background:none;width:100%;height:unset;}
    // }
    .sub-menu {
        border-width: 0;
        margin: 0;
        position: absolute;
        top: 31px;
        left: 50%;
        // width: 1200px;
        width:1028px;
        // height: 406px;
        // height:297px;
        // height:auto;
        text-align: left;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.24);
        // margin-left: -595px;
        background: ${NewLightTeal};
        display: none;
        transform: translate(-50%);
        // flex-direction:column;
        
        @media screen and (max-width: 1023px) {
            display: block;
            width: 100%;
            height: auto;
            position: relative;
            margin: 0;
            left: 0;
            top: 0;
            box-sizing: border-box;
            box-shadow: none;
            max-height: 0;
            overflow: hidden;
            transition: all 0.6s ease-in-out;
            transform: none;
        }
        .drop-icon {
            position: absolute;
            top: 0;
            right: 0;
            padding: 1em;
            display: none;
        }
        .drpdwn-lft {
            // display: inline-block;
            // display: flex;
            width: 215px;
            // height: 100%;
            // background: #def3ed;
            // background: #fff;            
            // border-left: 2px solid transparent;
            // border-right:1px solid #eee;
            // border-top:1px solid transparent;
            // padding: 18px 22px;
            // &:hover, &.activee{
            //   border-left:2px solid ${NewTeal};
            //   border-top:1px solid #eee;
            //   background:${NewLightTeal};
            //   border-right:none;
            //   border-bottom: 1px solid #ccc;
            //   @media screen and (max-width: 1023px) {border:none; background:none;}
            //   >ul.sub-sub-menu.bgnrDoubts-menu {
            //     display:block;
            //     position: absolute;
            //     left: 235px;
            //     top: 0;
            //     width: 792px;
            //     transition: all 0.6s ease-in-out;
            //     @media screen and (max-width: 1023px) {position:inherit;display:inherit;width:unset;}
            //   }
            //   @media screen and (max-width: 1023px) {border-left:none;border-bottom:none;border-top:none;}
            // }
          // New CSS
          ul{
            li{
              width:100%;
              :last-child{
                background:red;
              }
              label.menuTab-div.mesublabel, label.menuTab-div.mesublabel.activee {
                background: #fff;                    
                border-right:1px solid #eee;
                border-left:2px solid transparent;
                border-bottom:1px solid transparent;
                border-top:1px solid transparent; 
                bottom:0;
                @media screen and (max-width: 1023px) {background:unset;}
                label.LeftArrowIcon{
                    background: url(${LeftArrow}) no-repeat;
                    display:inline-block;                    
                    width: 10px;
                    height: 11px;
                    background-position: 0 0;
                    position: absolute;
                    right: 8px;
                    top: 19px;
                }
              &:hover{
                border-left:2px solid ${NewTeal};
                border-right:none;
                background:${NewLightTeal};
                color:${Teal};   
                border-bottom:1px solid #eee;
                border-top:1px solid #eee;                   
                @media screen and (max-width: 1023px) {border-left:none;border-right:none;background:unset;color:unset;transition:unset;}
                // ~ ul.sub-sub-menu.mesubdiv {
                //   display:block;
                //   position: absolute;
                //   left: 235px;
                //   top: 0;
                //   width: 792px;
                //   transition: all 0.6s ease-in-out;
                //   >li{
                //     width: 32%;
                //     display: inline-block;
                //     background: none;
                //     border: none;
                //     vertical-align:top;
                //     > ul.sub-sub-menu2 li{
                //       border:none;
                //       background:transparent;
                //       @media screen and (max-width: 1023px) {border:none;background:none;}
                //     }
                //     @media screen and (max-width: 1023px) {width:unset; display:unset;background:unset;border:unset;}
                //   }
                //   @media screen and (max-width: 1023px) {
                //     position: fixed;
                //     z-index: 10;
                //     left: 0;
                //     right: 0;
                //     top: 49px;
                //     bottom: 0;
                //     width:100%;
                //     transition: left 0.6s ease-in-out;
                //   }
                // }
              }
              &:after{

              }
            }
          }


            @media screen and (max-width: 1023px) {
                background: #e4f5f0;
                width: 100%;
                margin: 0;
                padding: 0;
                display: block;
                border-bottom: none;
                border-left: none;
                border-right:none;
            }
            label.menuTab-div {
                text-transform: capitalize;
                color: #666;
                padding: 1px 8px 1px 0;
                font-weight: 600;
                font-size: 13px;
                cursor: default;
                box-shadow: inset 0 -4px 0 transparent;
                // border-bottom: 1px solid #ccc;
            }
            label.menuTab-div.mesublabel {
                // color: ${PrimaryOrange};
                color:#666;
                // font-size: 16px;
                font-size:14px;
                padding:17px 8px;
                cursor: pointer;
                display: inline-block;
                width: 100%;
                @media screen and (max-width: 1023px) {
                    padding: 13px 16px 13px 24px;
                    color: ${CharcoalBlack};
                    width: 100%;
                    border-top: 1px solid #c1e8dc;
                    font-size: 14px;
                    -webkit-tap-highlight-color: transparent;
                }
                label.drop-icon {
                    position: absolute;
                    right: 0;
                    top: 0;
                    display: block;
                    &:after {
                        @media screen and (max-width: 1023px) {
                            background-position: -286px -8px;
                            content: "";
                        }
                    }
                }
                label.drop-icon.minus-icon {
                    @media screen and (max-width: 1023px) {
                        border: none;
                    }
                    &:after {
                        @media screen and (max-width: 1023px) {
                            background-position: -299px -8px;
                        }
                    }
                }
            }
            ul {
                li {
                    width: 100%;
                    line-height: 19px;
                    margin-bottom: 10px;
                    float: left;
                    padding: 0;
                    a {
                        padding: 0;
                        margin: 0;
                        border: none;
                        outline: 0;
                        color: ${CharcoalBlack};
                        font-size: 13px;
                        &:hover {
                            color: ${Teal};
                        }
                    }
                }
            }
        }
        .drpdwn-Rgt {
            // display: inline-block;
            // display: flex;
            // width: 980px;
            width: 215px;
            vertical-align: top;
            // padding: 8px 10px;
            padding: 0;
            background: ${White};
            @media screen and (max-width: 1023px) {
                background: #e4f5f0;
                width: 100%;
                margin: 0;
                padding: 0;
            }
            ul {
              width:100%;
                li {
                    // width: 188px;
                    width: 100%;
                    // float: left;
                    float:none;
                    // padding: 0;                    
                    display: inline-block;
                    
                    label.menuTab-div.mesublabel, label.menuTab-div.mesublabel.activee {
                      background: #fff;                    
                      border-right:1px solid #eee;
                      border-left:2px solid transparent;
                      border-bottom:1px solid transparent;
                      border-top:1px solid transparent; 
                      @media screen and (max-width: 1023px) {background:unset;}
                    &:hover{
                      border-left:2px solid ${NewTeal};
                      border-right:none;
                      background:${NewLightTeal};
                      color:${Teal};   
                      border-bottom:1px solid #eee;
                      border-top:1px solid #eee;                   
                      @media screen and (max-width: 1023px) {border-left:none;border-right:none;background:unset;color:unset;transition:unset;}
                        ~ ul.sub-sub-menu2 li label.menuTab-div{
                          color:${CharcoalBlack};
                        }



                      // ~ ul.sub-sub-menu.mesubdiv {
                      //   display:block;
                      //   position: absolute;
                      //   left: 235px;
                      //   top: 0;
                      //   width: 792px;
                      //   transition: all 0.6s ease-in-out;
                      //   >li{
                      //     width: 32%;
                      //     display: inline-block;
                      //     background: none;
                      //     border: none;
                      //     vertical-align:top;
                      //     > ul.sub-sub-menu2 li{
                      //       border:none;
                      //       background:transparent;
                      //       @media screen and (max-width: 1023px) {border:none;background:none;}
                      //     }
                      //     @media screen and (max-width: 1023px) {width:unset; display:unset;background:unset;border:unset;}
                      //   }
                      //   @media screen and (max-width: 1023px) {
                      //     position: fixed;
                      //     z-index: 10;
                      //     left: 0;
                      //     right: 0;
                      //     top: 49px;
                      //     bottom: 0;
                      //     width:100%;
                      //     transition: left 0.6s ease-in-out;
                      //   }
                      }
                    }
                  }
                    @media screen and (max-width: 1023px) {
                        width: 100%;
                        border-bottom: none;
                        border-left: none;
                        border-right:none;
                        background:none;
                        border-top:none;
                    }
                    a {
                        padding: 3px 10px;
                        margin: 0;
                        border: none;
                        outline: 0;
                        color: ${CharcoalBlack};
                        font-size: 13px;
                        @media screen and (max-width: 1023px) {
                            padding: 8px 8px 8px 32px;
                        }
                        &:hover {
                            color: ${Teal};
                        }
                    }
                    label.menuTab-div.mesublabel {
                        // color: ${PrimaryOrange};
                        color:#666;
                        // font-size: 16px;
                        font-size:14px;
                        // margin-top: 10px;
                        margin-top:0;
                        font-weight: 600;
                        // padding: 1px 8px;
                        padding:17px 8px;
                        // margin-bottom: 6px;
                        // border-bottom: 1px solid #ccc;
                        @media screen and (max-width: 1023px) {
                            padding: 13px 16px 13px 24px;
                            color: ${CharcoalBlack};
                            width: 100%;
                            border-top: 1px solid #c1e8dc;
                            margin: 0;
                            font-size: 14px;
                            border-bottom:none;
                        }
                    }
                    label.menuTab-div {
                        color: ${DarkSlate};
                        padding: 1px 8px;
                        margin-top: 10px;
                        @media screen and (max-width: 1023px) {
                            margin: 0;
                            color: ${CharcoalBlack};
                        }
                    }
                    label.drop-icon {
                        position: absolute;
                        right: 0;
                        top: 0;
                        display: block;
                        &:after {
                            @media screen and (max-width: 1023px) {
                                background-position: -286px -8px;
                                content: "";
                            }
                        }
                    }
                    label.drop-icon.minus-icon {
                        @media screen and (max-width: 1023px) {
                            border: none;
                        }
                        &:after {
                            @media screen and (max-width: 1023px) {
                                background-position: -299px -8px;
                            }
                        }
                    }
                }
                li.clgByExam {
                    // width: 376px;
                    width:100%;
                    @media screen and (max-width: 1023px) {
                        width: 100%;
                    }
                    div.clgByExm-Dv {
                        width: 376px;
                        // display: block;
                        display:none;
                        clear: both;
                        @media screen and (max-width: 1023px) {
                            max-height: 0;
                            overflow: hidden;
                            width: inherit;
                            transition: all 0.6s ease-in-out;
                        }
                        ul.clg-exList {
                            clear: unset;
                            float: left;
                            width: 50%;
                            @media screen and (max-width: 1023px) {
                                width: 100%;
                                float: none;
                            }
                            li {
                                float: none;
                                @media screen and (max-width: 1023px) {
                                    border-bottom: none;
                                    border-color: transparent;
                                }
                                &:nth-child(-n + 1) label.fnt-wt.menuTab-div {
                                    margin-top: 10px;
                                    @media screen and (max-width: 1023px) {
                                        margin-top: 4px;
                                    }
                                }
                                label {
                                    @media screen and (max-width: 1023px) {
                                        font-size: 13px;
                                        border: none;
                                        padding: 10px 8px 2px 24px;
                                    }
                                }
                            }
                        }
                    }
                    div.clgByExm-Dv.sub-sec-show {
                        @media screen and (max-width: 1023px) {
                            // max-height: 100em;
                            // transition: all 0.6s ease-in-out;
                        }
                    }
                    &:hover{
                      div.clgByExm-Dv {
                        display:block;
                        position: absolute;
                        left: 235px;
                        top: 0;
                        width: 792px;
                        transition: all 0.6s ease-in-out;
                      }
                    }
                }
            }
        }
        ul.sub-sub-menu {
          display:none;
            @media screen and (max-width: 1023px) {
                max-height: 0;
                overflow: hidden;
                transition: all 0.6s ease-in-out;
                display: block;
            }
            li {
                @media screen and (max-width: 1023px) {
                    border-bottom: none;
                    border-color: transparent;
                    margin: 0;
                }
                label.menuTab-div {
                    @media screen and (max-width: 1023px) {
                        border-top: none;
                        padding: 10px 8px 2px 24px;
                        font-size: 13px;
                    }
                }
                a {
                    @media screen and (max-width: 1023px) {
                        padding: 8px 8px 8px 32px;
                        box-shadow: none;
                        background: 0 0;
                        color: ${CharcoalBlack};
                        font-size: 13px;
                    }
                }
            }
        }
        ul.sub-sub-menu.sub-sec-show {
          // display:block;
          // display:flex;
          // position: absolute;
          // left: 235px;
          // top: 0;
          // width:792px;
          // background:#fff;
           li{
            // width: 32%;
            // display: block;
            // background: none;
            // border: none;
            @media screen and (max-width: 1023px) {width:unset; display:unset;background:unset;border:unset;}
          }
            @media screen and (max-width: 1023px) {
                max-height: 100em;
                // transition: all 0.6s ease-in-out;
                // position:unset;
                // left:unset;
                // top:unset;
                // width:unset;
                // display:block;
                background:#e4f5f0;

                position: fixed;
                z-index: 10;
                left: 0;
                right: 0;
                top: 49px;
                bottom: 0;
                width:100%;
                transition: left 0.6s ease-in-out;
            }
        }
        ul.sub-sub-menu.sub-sec-show.bgnrDoubts-menu{
          display:block;
          @media screen and (max-width: 1023px) {display:unset}
          > li{
            float:none;
          }
        }
        ul.sub-sub-menu.sub-sec-show > li ul.sub-sub-menu2 li{
          width:100%;
          @media screen and (max-width: 1023px) {width:unset}
        }
    }
    .sub-menu.sub-show {
        @media screen and (max-width: 1023px) {
            max-height: 200em;
            transition: all 0.6s ease-in-out;
        }
    }
    .full-screen-close {
        @media screen and (max-width: 1023px) {
            width: 100%;
            height: 100%;
            position: fixed;
            cursor: pointer;
            top: 0;
            left: 0;
        }
    }
`;

export const MenuAnchor = styled.div`
    color: ${White};
    font-size: 10px;
    display: inline-block;
    text-align: center;
    position: absolute;
    bottom: 4px;
    left: 7px;
    &:before {
        content: "";
        display: block;
        content: "";
        background: url(${gnb_sprite}) no-repeat;
        background-position: -239px -6px;
        width: 18px;
        height: 18px;
        display: inline-block;
        top: -22px;
        left: 2px;
        position: absolute;
    }
    ${media.laptop`display:none;`}
`;
export const Nav = styled.nav`
  width: 100%;
  text-align: center;
  position: relative;
  @media screen and (max-width: 1023px) {position: absolute; top: 0; left: 0;text-align:left;width:auto;}
  .main-menu {
     visibility: visible;
     z-index: 0;
     bottom: 0;
     margin-top: -33.8px;
     @media screen and (max-width: 1023px) {visibility:hidden;}
   }
   .fnt-wt {
     font-weight: 600;
    }
   ul span.drop-icon {
     background:url(${gnb_sprite}) no-repeat;
     background-position: -194px -41px;
     width: 10px;
     height: 6px;
     display: inline-block;
     margin-left: 4px;
     transition: .2s ease-in-out;
     position:relative;
   }
   label.menuTab-div.melabel.labelActiveTitle{font-weight:600;}
  ul{
    margin:0;
    padding:0;
    li{
      label.drop-icon{
        position: absolute;
        right: 0;
        top: 0;
        display:inline-block;
        list-style:none;
      }
      .sub-menu.active{
        @media screen and (min-width: 1024px) {display:flex;flex-direction:row;}
      }
      &:hover span.drop-icon{
        transform: rotateZ(-180deg);
        transition: .2s ease-in-out;
      }     
    }
  }
    a{
      transition: all .125s ease-in-out;
      transition: box-shadow .2s,opacity .5s;
      padding: 1em 1.5em;
      font-size: 14px;
      position: relative;
      display: block;
      color: ${White};
      label.drop-icon{
        display:none;
      }        
      #toggle-menu {
        position: relative;
        display: block;
        color: ${White};
        display:none;
        padding: 1em 1.5em;
        background: #007075;
        @media screen and (max-width: 1023px) {padding: 12px; position: relative; margin: 10px; background: 0 0;display:block;}
        .drop-icon {
          position: absolute;
          right: 0;
          top: 0;
          @media screen and (max-width: 1023px) {
            margin: 0;
            left: 0;
          }
          &:after{
              @media screen and (max-width: 1023px) {
                  content: '';
                  background:url(${gnb_sprite}) no-repeat;
                  background-position: -239px -6px;
                  width: 18px;
                  height: 18px;
                  display: inline-block;
                  top: -2px;
                  left: 2px;
                  position:absolute;
                }
          }
        }
        p.menu-cls{
          @media screen and (max-width: 1023px) {
            padding: 0;
            color: #fff;
            font-size: 10px;
            text-transform: uppercase;
            background-color: transparent;
            border: none;
            box-shadow: none;
            left: -3px;
            top: 16px;
            position: absolute;
            display: inline-block;
            font-weight: 400;
          }
        }
      }
    }
    a.level1CustomLink{
        padding: 0;
        border: none;
        transition: none;
        width: 100%;
        maxWidth: 100%;
      }
    a.panel-anchor {
      padding: 0;
      border-color: transparent;
      box-shadow: none;
      @media screen and (max-width: 1023px) {display:inline-block;}
    }
    label.menuTab-div {
      transition: all .125s ease-in-out;
      transition: box-shadow .2s,opacity .5s;
      padding: 0 1.4em .99em 1.4em;
      font-size: 14px;
      position: relative;
      display: block;
      color: ${White};
      cursor:pointer;
      line-height:14px;
      bottom:-3px;
      }
      label.menuTab-div.melabel{
        &.active, &:hover{
          background-color: transparent;
          color:${White};
          box-shadow: inset 0 -4px 0 #f9b34e;
          @media screen and (max-width: 1023px) {color:${CharcoalBlack}; box-shadow:none; -webkit-tap-highlight-color:transparent;}
        }        
    }
  }
  .NavLinks-Head{
    background:${NewTeal};
    color:${White};
    display:flex;
    flex-direction:row;
    align-items:center;
    p{
      width: 94%;
      line-height: 29px;
      font-size: 1rem;
      font-weight: 600;
      padding: 10px;
    }
    i.CrossIcon{
      font-size:26px;
      line-height:21px;
      padding:14px;
    }
  }
  .lgn-section{
    @media screen and (max-width: 1023px) {position: relative;  z-index: 2; height: 100%; /*height: calc(100% - 152px);*/  background: #fff; overflow-y: scroll;}
    ul {
      clear: both;
      display: inline-block;
      @media screen and (max-width: 1023px) {width:100%;}
      li{
        float:left;
        list-style:none;
        position:static;
        display:inline-block;
        // For development purpose only
        &:nth-child() >div >div{
          display:flex;
        }
        label.drop-icon{
          @media screen and (max-width: 1023px){position:absolute; top:0; right:0; padding: 0 8px;font-size: 1.8em;text-align: center; background-color: transparent; text-shadow: 0 0 0 transparent; color: #008489;  line-height: 1.8em;}
          &:after{
            @media screen and (max-width: 1023px){
              background:url(${GNBSprite_New}) no-repeat;
              display: inline-block;
              content: '';              
              background-position: -194px -3px;
              width: 16px;
              height: 18px;
              top: -4px;
              position: relative;
            }
          }
        }
        label.drop-icon.minus-icon{
          @media screen and (max-width: 1023px){border:none;}
          :after{
            @media screen and (max-width: 1023px){
              display: inline-block; 
              content: ''; 
              background:url(${GNBSprite_New}) no-repeat;
              background-position: -179px -3px;
              width: 16px;
              height: 18px;
              top: -4px;
              position: relative;
              
            }
          }
        }
        @media screen and (max-width: 1023px){width:100%;text-align:left;}
        &:first-child{
          label.menuTab-div.melabel{
            @media screen and (max-width: 1023px){border-top:none;}
          }
        }
        label.menuTab-div{
          @media screen and (max-width: 1023px) {color: ${CharcoalBlack}; font-weight: 400; display: inline-block; width: 100%; padding: 13px 16px; border-top: 1px solid #c1e8dc; text-transform: capitalize;}
          }
        }
        label.drop-icon:after{
          @media screen and (max-width: 1023px) {display: inline-block;content: '';background-position: -260px -8px;width: 13px;height: 18px;
          }
        }
      }
  }
}
.main-menu {
  @media screen and (max-width: 1023px){
    width: 100%;
    backface-visibility: hidden;
    left: -23em;
    top: 31px;
    bottom: -1px;
    overflow: auto;
    transform: translate3d(0,0,0);
    position:fixed;
    z-index:99999;
    transition:all 0.6s ease-in;
    background:#fff;
  }
}
.main-menu.hamburger-open, .navHeight.innerPageHeader #menu .main-menu.hamburger-open{
    @media screen and (max-width: 1023px){
        left:0;
        // transition:all 0.6s ease-in;
        visibility:visible;
      }
}

`;

export const HeaderDiv = styled.div`
     ${media.mobile`position:relative;`}  
  .main-header {
    top: 0;
    left: 0;
    right: 0;
    z-index: 14;
    font-size:16px;
    @media screen and (max-width: 1023px){
    line-height:14px;
   }
  }
  .navStickyHeight {
      height: 55px
  }

  .navheaderP {
      background-color: #007075;
      box-shadow: 0 2px 2px rgba(0,0,0,.3);
      -webkit-box-shadow: 0 2px 2px rgba(0,0,0,.3);
      -moz-box-shadow: 0 2px 2px rgba(0,0,0,.3);

      top: 0;
      left: 0;
      right: 0;
      transition: all .3s linear
  }

  .navheaderP.navRelative {
      position: relative
  }



  .navHeight {
      @media screen and (min-width: 1024px) {
      height: 88px;
    }
  }

  .navStickyHeight.innerPageHeader #menu .main-menu {
      transition: all .2s linear;
      visibility: hidden
  }

  .navHeight.innerPageHeader #menu .main-menu {
      visibility: visible
  }

  .navHeight .logo-icn {
    @media screen and (min-width: 1024px) {
      transition: all .3s linear;
      transform: scale(1)
    }
  }

  .navStickyHeight .logo-icn {
      transition: all .3s linear;
      transform: scale(.8);
      top: -9px
  }

  .navHeight .logo {
    @media screen and (min-width: 1024px) {
      transition: all .3s linear;
      height: 88px;
    }
  }

  .navStickyHeight .logo {
      transition: all .3s linear;
      height: 55px
  }

  .navStickyHeight #menu {
      bottom: 5px
  }

  .navStickyHeight .lgn-sgnDiv {
      bottom: 15px
  }

  .navHeight .lgn-sgnDiv {
      bottom: 10px
  }

  .innerPageHeader #seachTextBox {
      display: inline-block;
      @media screen and (max-width: 1023px) {display:none;}
  }
.abrd-hdr {
    background: #007075;
    position: relative;
    box-shadow: none;
    display:inline-block;
    width:100%;
    line-height:12px;
      @media screen and (max-width: 1023px) {height:44px;}
}


.logo {
    display: inline-block;
    line-height: 100%;
    width: 204px;
    z-index: 2;
    position: relative;
    cursor:pointer;
      @media screen and (max-width: 1023px) {display: inline-block; text-align: left;  line-height: 100%;  bottom: 3px; left: 46px; position: relative; margin-left: 0; border-left: 1px solid rgba(0,0,0,.15); height: 44px;width:108px;}
}
.logo.noCursor{
  cursor:default
}
.abrd-hdr .logo a {
    outline: 0;
    height: 88px;
    @media screen and (max-width: 1023px) {display: inline-block; height: 44px; position: relative;}
}
.logo-icn {
    background-position: -4px 0;
    display: block;
    width: 180px;
    height: 67px;
    top: 8px;
    box-sizing: inherit;
    outline: 0;
    left: 17px;
    @media screen and (max-width: 1023px) {background-position: -2px 0; top: -10px; transform: scale(.6);  left: -34px;  position: absolute; text-align: left;}
}
  .search-tabContent {
      background: #fff;
      vertical-align: top;
      width: 648px;
      height: 36px;
      line-height: 36px;
      padding: 0 10px;
      font-size: 12px;
      color: #999;
      border-radius: 2px;
      position: absolute;
      cursor: pointer;
      display: none;
      top: 10px;
      left: 50%;
      margin-left: -325px;
      z-index:1;
      @media screen and (max-width: 1023px) {display:none;}
  }
  button.SearchBtn {
      cursor: pointer;
      border: none;
      position: absolute;
      right: 0;
      font-size: 16px;
      font-weight: 700;
      top: 0;
      color: #fff;
      height: 36px;
      border-top-right-radius: 2px;
      background: ${PrimaryOrange};
      outline: 0;
      width: 110px;
      border-bottom-right-radius: 2px;
      text-shadow: 1px 1px 3px rgba(0,0,0,.3);
      
  }
  .lggd-sgnDiv, .lgn-sgnDiv {
      float: right;
      right: 22px;
      font-size: 14px;
      color: #fff;
      line-height: 22px;
      position: absolute;
      bottom: 6px;
      z-index:3;
      @media screen and (max-width: 1023px) {display:none;}
  }
  .lggd-sgnDiv{
    right:32px;
  }
  .navHeight .lgn-sgnDiv {
      bottom: 10px;
  }
  .lgn-sgnDiv .a-loginSgnup a {
      color: #fff;
      font-size: 12px;
      cursor: pointer;
      line-height: 14px;
      display: inline-block;
      font-weight: 600;
      text-decoration: none;
      outline: 0;
      padding: 5px 6px;
      &:hover{        
        background: rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        cursor: pointer;
        font-weight:600; 
      }
      
  }
  .signupBtn{

  }
  .registerPipe {
      opacity: .4;
      margin:0 3px;
  }
  .src-fldDiv {
      display: none;
      @media screen and (max-width: 1023px) {display:block;float: right; padding: 0; height: 44px;position:relative;right:0px;}
  }
  .src-fldDiv.mobileLoggedIn{
    right:20px;
  }
  .src-fldDiv i.mobileLoggedIn{
        content:'';
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid #fff;
        position: absolute;
        right: -10px;
        top: 19px;
  }
  .hide {
      display: none;
  }
  .header-shortlist {
      float: left;
      font-size: 10px;
      margin-right: 12px;
      @media screen and (max-width: 1023px) {float: left; font-size: 10px;  margin-right: 15px;}
      a{
        position: relative;
        display: inline-block;
        top: -2px;
        outline: 0;
        @media screen and (max-width: 1023px) {position: relative; height: 44px; line-height: 50px;  display: inline-block;}
        .shortlist-icon {
            background-position: -208px -27px;
            width: 20px;
            height: 21px;
            top: 2px;
            display: inline-block;
        }
       }
      }
  }
  a.search-hdr-icon, a.user-hdr-icon{
    @media screen and (max-width: 1023px) {padding: 0 8px; height: 44px; line-height: 44px;  display: inline-block;}
    .src-icon {
      @media screen and (max-width: 1023px) {background: url(${gnb_sprite}) no-repeat;background-position: -215px -4px; width: 20px; height: 20px;  top: 4px;  display: inline-block;position:relative;}
    }

    .user-icon {
      @media screen and (max-width: 1023px) {background: #359093; width: 26px;  height: 26px; border: 1px solid var(--Teal); border-radius: 50%; display: inline-block; top: 9px; position: relative;}
      &:after{
        content: ''; background-position: -185px 0; width: 21px; height: 22px; display: inline-block; top: -3px; text-align: center; left: 0px;
        @media screen and (max-width: 1023px) {top: -8px;}
        }
      }
    }
  }

  @media screen and (max-width: 1023px) {
    .needCounsling-icon{
      background:url(${needCounselingIcon}) no-repeat; width:18px; height: 18px; display: inline-block; cursor: pointer; position: relative;
      top: 8px;
      left: 1px;
    }
  }
  .logo-icn, .mail-icn, .phone-icn, .rgt-logo:after, .shortlist-icon, .srch-icon, .user-icon:after, i.fb-icn, i.naukri-logo, i.yutube-icn {
    background: url(${gnb_sprite}) no-repeat;
    position: relative;
  }
  && a.user-hdr-icon .user-icon:after{
    background: url(${GNBSprite_New}) no-repeat;
    background-position: -109px -35px;
    width: 21px;
    height: 22px;
    display: inline-block;
    top: -6px;
    text-align: center;
    left: 0px;
  }
  .lggd-sgnDiv a.user-hdr-icon {
    padding: 0;
    color: #fff;
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    vertical-align: middle;
    text-decoration: none;
    font-weight: 600;
    outline: 0;
    cursor: pointer;
  }
   .lggd-sgnDiv a.user-hdr-icon:after {
        content:'';
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid #fff;
        position: absolute;
        right: -19px;
        top: 10px;
   }
  .lggd-sgnDiv a.user-hdr-icon .user-icon {
    background: #359093;
    width: 26px;
    height: 26px;
    border: 1px solid #008489;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    margin-right: 7px;
    vertical-align: middle;
  }
  .shortlist-Count{
    position: absolute;
    top: -5px;
    left: 19px;
    color: ${White};
  }
  img.small-pp-img { width: 28px;
    height: 28px;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 4px;
  }
  .lggd-sgnDiv a:first-child{
      margin-right:8px;
      // color:#fff;
  }
  .lgn-sgnDiv.needCounsling_Link > a{
      color:#fff;
      margin-right:8px;
  }
  `;
export const LoggedSignInWrapper = styled.div`
    width: ${(props) => (props.loggedOutDiv ? "130px" : "245px")};
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
`;

export const ContactUseHeaderBox = styled.div`
    color: ${White};
    font-size: 0.75rem;
    line-height: 18px;
    margin-right: 12px;
    font-weight: 600;
    cursor: pointer;
    position: relative;
    vertical-align: middle;
    width: 110px;
    padding: 2px 10px;
    border-radius: 4px;

    &:before {
        content: "";
        background: url(${contactUsPhoneIcon}) no-repeat;
        display: inline-block;
        width: 12px;
        height: 12px;
        position: relative;
        left: -4px;
        top: 2px;
    }
    &:after {
        content: "";
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid #fff;
        position: absolute;
        right: 8px;
        top: 8px;
        transform: ${(props) => (props.arrowRotate ? "rotate(180deg)" : "")};
    }
    &:hover {
        background: rgba(0, 0, 0, 0.1);
    }
`;
export const ContactUseDetailsBox = styled.div`
    background: ${White};
    position: absolute;
    top: 34px;
    left: ${(props) => (props.loggedOutDiv ? "-31px" : "0")};
    width: 192px;
    border-radius: 8px;
    padding: 0px 16px;
    box-shadow: 0 2px 2px #ccc;
    a {
        color: ${CharcoalBlack};
        font-size: 0.875rem;
        border-bottom: 1px solid ${LightGray};
        padding: 10px 0;
        margin-right: 0;
        &:hover,
        &:visited {
            color: ${CharcoalBlack};
        }
    }
    &:before {
        content: "";
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-top: 12px solid #fff;
        position: absolute;
        right: 84px;
        top: -8px;
        transform: rotate(180deg);
    }
`;
export const ContactUsHeadPhoneIcn = styled.i`
    background: url(${ContactUsHeadPhnIcn}) no-repeat;
    display: inline-block;
    width: 18px;
    height: 18px;
    margin-right: 6px;
    vertical-align: middle;
`;
export const ContactUsCallIcon = styled.i`
    background: url(${ContactUsPhnIcn2}) no-repeat;
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 6px;
    vertical-align: middle;
`;
export const ContactUsMobileHeaderWrapper = styled.div`
    display: inline-block;
    position: relative;
    margin-right: 7px;
`;
export const ContactUsMobileHeaderBox = styled.div`
    display: inline-block;
    vertical-align: middle;
    width: 30px;
    height: 30px;
    background: #008489;
    border-radius: 50%;
    text-align: center;
    position: relative;
    // left: -7px;
`;
export const ContactUseDetailsMobBox = styled.div`
    background: ${White};
    position: absolute;
    top: 40px;
    width: 210px;
    border-radius: 8px;
    padding: 0px 12px;
    z-index: 1;
    right: ${(props) => (props.hideGNBSearch ? "-41px" : "-81px")};
    box-shadow: 0 2px 3px #ccc;
    a {
        color: ${CharcoalBlack};
        font-size: 0.875rem;
        border-bottom: 1px solid ${LightGray};
        padding: 10px 0;
        margin-right: 0;
        &:hover,
        &:visited {
            color: ${CharcoalBlack};
        }
    }
    &:before {
        content: "";
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-top: 12px solid #fff;
        position: absolute;
        right: ${(props) => (props.hideGNBSearch ? "45px" : "84px")};
        top: -8px;
        transform: rotate(180deg);
    }
`;

export const BottomFreeAssistanceWrapperDiv = styled.div`
    @media screen and (max-width: 1023px) {
        padding: 12px;
        bottom: 0;
        position: absolute;
        display: inline-block;
        width: 100%;
        height: 112px;
    }
`;
export const BottomFreeAssistanceDiv = styled.div`
    @media screen and (max-width: 1023px) {
        background: #f1fbff;
        border-radius: 10px;
        padding: 12px;
        strong {
            display: block;
            font-size: 14px;
            line-height: 16px;
            color: ${CharcoalBlack};
            font-weight: 600;
            margin-bottom: 12px;
        }
    }
`;
export const BottomFreeAssistanceButtonSection = styled.div`
    @media screen and (max-width: 1023px) {
        width: 100%;
        display: inline-flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        && a {
            background: ${White};
            border: 1px solid #eaf5fa;
            border-radius: 8px;
            display: inline-block;
            padding: 8px;
            color: #000;
            width: 49%;
            font-size: 12px;
        }
        strong {
            display: inline-block;
            margin-bottom: 0;
            font-size: 12px;
        }
    }
`;

// export const VirtualWebinarDiv = styled.div`
//     position: sticky;
//     top: 0;
//     background-color: #f37316;
//     color: #fff;
//     z-index: 999;
//     padding: 10px;
//     text-align: center;
//     font-weight: 600;
//     font-size: 14px;
//     line-height: 18px;
//     && a {
//         color: #fff;
//         background: #1048c3;
//         display: inline-block;
//         padding: 2px 4px;
//         @media screen and (max-width: 1023px) {
//             display: inline-block;
//             width: 125px;
//         }
//     }
// `;
